module.exports = __webpack_public_path__ + "img/wenzi1.502c931c.webp";